module.exports = __webpack_public_path__ + "img/entrance-2.de66a60c.jpg";